<div class="container-fluid p-4">

  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">

    <!-- LEFT : TITLE -->
    <h4 class="fw-bold mb-0">Order Processing</h4>

    <!-- RIGHT : BUTTONS -->
    <div class="d-flex gap-2 mt-2 mt-md-0">
      <button class="btn btn-success" (click)="downloadExcel()">
        <i class="bi bi-file-earmark-excel"></i> Excel
      </button>

      <button class="btn btn-danger" (click)="downloadPDF()">
        <i class="bi bi-file-earmark-pdf"></i> PDF
      </button>
    </div>

  </div>

  <div class="container-fluid">
    <div class="table-style table-responsive table-bordered">
      <table class="table table-head-fixed text-nowrap text-center">

        <thead class="table-dark">
          <tr>
            <th>S.No</th>
            <th>Invoice No</th>
            <th>Customer Name</th>
            <th>Phone Number</th>
            <th>Total Items</th>
            <th>Shipping Partner</th>
            <th>Status</th>
            <th>Action</th>
            <th>Print</th>
          </tr>
        </thead>

        <tbody *ngIf="orders.length > 0">
          <tr *ngFor="let order of orders| filter: searchText; let i = index">

            <td>{{i + 1}}</td>
            <td>{{ order?.invoiceNumber }}</td>
            <td>{{ order?.customerName }}</td>
            <td>{{ order?.phoneNumber }}</td>
            <td class="text-center">
              {{ getItemCount(order) }}
            </td>
            <td>{{ order?.shippingPartner }}</td>
            <td>
              <span class="badge bg-warning">
                {{ order?.orderStatus }}
              </span>
            </td>

            <td>
              <button class="btn btn-primary btn-sm" (click)="openItemsModal(order)">
                View Items
              </button>
            </td>

            <td>
              <button class="btn btn-warning btn-sm" (click)="printBill(order)">
                Print Bill
              </button>
            </td>

          </tr>
        </tbody>

      </table>
    </div>
  </div>

</div>


<!-- ===== MODAL BACKDROP ===== -->
<div class="custom-backdrop" *ngIf="isItemsModalOpen">

  <!-- ===== MODAL ===== -->
  <div class="custom-modal" (click)="$event.stopPropagation()">

    <div class="modal-header">
      <h5 class="modal-title">
        Order Items - {{ selectedOrder?.invoiceNumber }}
      </h5>

      <button class="btn-close" (click)="closeItemsModal()"></button>
    </div>

    <div class="modal-body">

      <table class="table table-bordered text-center">
        <thead class="table-light">
          <tr>
            <th>S.No</th>
            <th>Product Image</th>
            <th>Category</th>
            <th>Sub Category</th>
            <th>Product</th>
            <th>Barcode Number</th>
            <th>Size</th>
            <th>Qty</th>
            <th>Status</th>
            <th>Update</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of orderItems; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="image-card d-flex justify-content-center align-items-center">
                <a [href]="getImageById(item?.imageDetails?.imageDetailsId)" target="_blank" rel="noopener noreferrer">
                  <img [src]="getImageById(item?.imageDetails?.imageDetailsId)" class="img-fluid rounded shadow-sm preview-img"
                    alt="Image Preview" />
                </a>
              </div>
            </td>
            <td>{{ item?.categoryName }}</td>
            <td>{{ item?.subCategoryName }}</td>
            <td>{{ item?.productName }}</td>
            <td>{{ item?.barcode}}</td>
            <td>{{ item?.size}}</td>
            <td>{{ item?.quantity }}</td>

            <td>
              <select class="form-select" [(ngModel)]="item.orderStatus">
                <option value="">Select</option>
                <option value="PLACED">PLACED</option>
                <option value="PROCESSING">PROCESSING</option>
              </select>
            </td>

            <td>
              <button class="btn btn-success btn-sm" (click)="updateItem(item)">
                Update
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="updateAllItems()">
        Update All Items
      </button>

      <button class="btn btn-secondary" (click)="closeItemsModal()">
        Close
      </button>
    </div>

  </div>
</div>